import React from 'react';
import { SyncLoader } from 'react-spinners';

const MyPageLoading = ({ loading }) => {
  const override = { textAlign: 'center', height: '300px !important' };
  return <SyncLoader css={override} sizeUnit={'px'} size={15} color={'#00b9ef'} loading={loading} />;
};

export default MyPageLoading;
